import { useQuery } from '@tanstack/react-query'

import { CORPORATE_KEY, corporateApi } from '@/api/corporate'
import type { Corporation } from '@/api/types'

/** La société du livre : une seule requête, partagée par le menu et la section. */
export const CORPORATION_QUERY = {
  queryKey: [...CORPORATE_KEY, 'corporation'] as const,
  queryFn: corporateApi.corporation,
  staleTime: 60_000,
}

/**
 * Lot 45 : le livre des minutes n'existe que pour ses gardiens. `GET /corporate`
 * répond 200 (la société, ou `null` à un administrateur tant que le livre n'est
 * pas ouvert) ; pour tout autre compte, 404 — l'entrée du menu ne s'affiche pas.
 */
export function useCorporateAccess(): {
  visible: boolean
  corporation: Corporation | null | undefined
} {
  const query = useQuery({ ...CORPORATION_QUERY, retry: false })
  return { visible: query.isSuccess, corporation: query.data }
}
